/* 📦 LIBS */
import { useState, useRef } from "react";
import { useTranslation } from "react-i18next";

/* 🎨 STYLES */
import { ChatContainer, IrisButton, ChatHeader, ChatMessages, ChatInput, LoadingDots, MessageBubble } from "./styles";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { toast } from "react-toastify";
import { SendIcon, ChatIcont } from "../../Assets/icons";

let IrisUrl
try {
    IrisUrl = process.env?.REACT_APP_IRIS_URL ? process.env.REACT_APP_IRIS_URL : "https://iris.augenengenharia.com";
} catch (error) {
    IrisUrl = "https://iris.augenengenharia.com";
}


const Iris = () => {
    const { t } = useTranslation();
    const user = useSelector(state => state.userReducer);
    const IrisToken = useRef(null);
    const systemToken = useRef(null);
    const chatRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [input, setInput] = useState("");


    const toggleChat = () => {
        if(isOpen === false && !IrisToken.current){
            initializeChat();
        }
        setIsOpen((prev) => !prev);
        setTimeout(() =>{
            chatRef?.current?.scrollIntoView({ behavior: "smooth", block: "end" })
        }, 100);
    };

    const handleSend = async () => {
        if (!input.trim()) return;
        if(loading){
            toast("Aguarde a resposta da Iris antes de enviar uma nova mensagem.", {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            return;
        }
        addMessage("user", input);
        sendMessageToIris(input);
        setInput("");        
    };

    const addMessage = (sender, text) => {
        if (!chatRef.current) return;

        const bubble = document.createElement("div");
        bubble.className = sender === "user" ? "user-bubble" : "iris-bubble";

        bubble.innerHTML = FormatText(text);

        chatRef.current.appendChild(bubble);

        setTimeout(() => {
            bubble.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 50);
    };

    const FormatText = (text_line) => {
        let textResp = text_line;

        // **negrito**
        textResp = textResp.replace(/\*\*(.*?)\*\*/g,
            '<span style="font-weight: bold;">$1</span>'
        );

        // *itálico*
        textResp = textResp.replace(/\*(.*?)\*/g,
            '<span style="font-style: italic;">$1</span>'
        );

        // [texto](link)
        textResp = textResp.replace(
            /\[([^\]]+)\]\(([^)]+)\)/g,
            '<a href="$2" target="_blank">$1</a>'
        );

        // ### texto → negrito
        textResp = textResp.replace(
            /^#+\s*(.*)$/gm,
            '<span style="font-weight: bold;">$1</span>'
        );

        // Parágrafo
        let html = `<p>${textResp}</p>`;

        return html;
    }

    async function sendMessageToIris(message) {
        try {
            setLoading(true);
            const response = await fetch(`${IrisUrl}/chat`, {
                    method: "POST",
                    headers: {
                        "Authorization": `Bearer ${systemToken.current}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ 
                        "question": message,
                        "token": IrisToken.current,
                        "stream": false,
                        "no_history": false,
                    }),
                });
            if (!response.ok) {
                throw new Error(response?.detail || t("iris.connection-failed"))
            };
            const data = await response.json();
            addMessage("Iris", data.content);
        } catch (error) {
            console.log("Error : ", error);
            toast("Error : " + error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            return null;
        } finally {
            setLoading(false);
        }
    }

    async function getSystemToken() {
        try {
            const response = await fetch(`${IrisUrl}/auth`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ "system_token": user.access_token }),
                });
            if (!response.ok) {
                throw new Error(response?.datail || t("iris.connection-failed"))
            };
            const data = await response.json();
            return data.access_token;
        } catch (error) {
            console.log("Error: ", error);
            toast("Error: " + error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            return null;
        }
    }

    async function getIrisToken(){
        try {
            const token = await getSystemToken();
            if (!token) return;
            systemToken.current = token;
            const response = await fetch(`${IrisUrl}/create?token=${token}`, {
                method: "GET",
            })
            if (!response.ok) {
                throw new Error(response?.datail || t("iris.connection-failed"))
            };
            const data = await response.json();
            return data.token;
        } catch (error) {
            console.log("Error ", error);
            toast("Error: " + error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            return null;
        }
    }

    async function initializeChat() {
        setLoading(true);
        const token = await getIrisToken();
        if (!token) return;
        setLoading(false);
        IrisToken.current = token;
        addMessage("Iris", t("iris.first-message"));
    }

    return (
        <>
            <IrisButton onClick={toggleChat}>
                <img src={ChatIcont} alt="Iris Chat" />
            </IrisButton>

            <ChatContainer $isOpen={isOpen}>
                <ChatHeader>
                    <h3>Copilot</h3>
                    <button onClick={toggleChat}>✕</button>
                </ChatHeader>

                <ChatMessages ref={chatRef}>
                    {loading && 
                        <MessageBubble $sender="Iris">
                            <LoadingDots color="#333">
                                <span></span>
                                <span></span>
                                <span></span>
                            </LoadingDots>
                        </MessageBubble>
                    }
                </ChatMessages>

                <ChatInput $loading={loading}>
                    <input
                        type="text"
                        placeholder={t("inputs.message.placeholder")}
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        onKeyDown={(e) => e.key === "Enter" && handleSend()}
                    />
                    <button onClick={handleSend}>
                        <img src={SendIcon} alt="Send" />
                    </button>
                </ChatInput>
            </ChatContainer>
        </>
    );
};

export default Iris;
